// extracted by mini-css-extract-plugin
module.exports = {"root":"OwnershipGroups_root__3nHL1","sidebar":"OwnershipGroups_sidebar__13PRs","tableFooter":"OwnershipGroups_tableFooter__2QAdZ"};